module.exports = __webpack_public_path__ + "static/media/emptyPending.3f219dea.svg";